
import { SelectData } from "@/data/SelectData";
import AbstractVue from "@/views/AbstractVue";
import { Options } from "vue-class-component";

@Options({
  props: ["title", "icon", "optionData", "selectedOption"],
})
export default class SearchableSelect extends AbstractVue {
  title: string;
  icon: string;
  optionData: SelectData[];
  selectedOption: SelectData;

  placeholder = "Search Outcome...";
  searchText = "";
  private _isFocused = false;

  get isFocused(): boolean {
    return this._isFocused;
  }
  set isFocused(val: boolean) {
    this._isFocused = val;
  }

  // Watch searchText and update selected to first filtered option
  mounted() {
    this.$watch("searchText", () => {
      const filtered = this.filteredOptions;
      if (filtered.length > 0) {
        this.selected = filtered[0];
      } else {
        this.selected = null as any;
      }
    });
  }
  get selected(): SelectData {
    return this.selectedOption;
  }

  set selected(value: SelectData) {
    this.$emit("update", value);
  }

  get filteredOptions(): SelectData[] {
    const text = this.searchText ? this.searchText.toLowerCase() : "";
    return this.optionData.filter((option: SelectData) => {
      const name = option.name ? option.name : String(option);
      return name.toLowerCase().includes(text);
    });
  }
}
